import { render } from "./AlcadaDescontos.vue?vue&type=template&id=a8c01810&scoped=true"
import script from "./AlcadaDescontos.vue?vue&type=script&lang=js"
export * from "./AlcadaDescontos.vue?vue&type=script&lang=js"

import "./AlcadaDescontos.vue?vue&type=style&index=0&id=a8c01810&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8c01810"]])

export default __exports__